import { TopBottomCategories } from './components/top-bottom-keys/top-bottom-keys'

export const BG_COLOR: Record<TopBottomCategories, string> = {
  uppercase: '#00B2C5',
  lowercase: '#10A5F9',
  num: '#EABC48',
  punctuation: '#B457BC',
}
